import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

const services = [
  {
    title: "Annual Impact Reports: ",
    details:
      "The grantee need not be based in a secondary city, but their work must contribute to the economic growth and development of secondary cities.",
  },
  {
    title: "Quarterly Updates and Funder-Grantee Townhall meetings: ",
    details:
      "The winning project must have a clear problem statement, locally relevant solution, measurable impact metrics, demonstrate connections to the communities the innovation serves, proof of concept (i.e., you have implemented at a small scale) and there is a clear path for financial sustainability. For instance, a project aimed at increasing renewable energy access in rural areas should include specific targets for household reach, cost reductions, and greenhouse gas reductions, as well as a plan for financial sustainability that does not rely on donor funding.",
  },
  {
    title: "Interactive Dashboards:",
    details:
      "AIR prioritizes projects that address the needs of underserved groups, including women, youth, and people with disabilities, to ensure that the benefits of innovation and resilience are equitably distributed.",
  },
  {
    title: "Interactive Dashboards:",
    details: "Winning grants can come from non-profit or for-profit entities.",
  },
];

const WhoWillFund = () => {
  return (
    <Box margin={{ xs: "25% 0% 25% 0%", sm: "0% 0% 5% 0%" }}>
      <Typography
        variant="h3"
        fontWeight={700}
        paddingBottom={{ xs: "6%", sm: "2%" }}
        textAlign={"left"}
        color={"#39484E"}
      >
        {" "}
        Who Will We Fund?
      </Typography>
      <Typography
        variant="h6"
        fontWeight={400}
        textAlign={"left"}
        paddingBottom={{ xs: "4%", sm: "1%" }}
        color={"#000"}
      >
        To qualify for AIR Fund’s equity-free funding, projects must align with
        AIR’s principles of sustainability, scalability, and inclusivity.
      </Typography>
      <Box width={"100%"}>
        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          color={"#39484E"}
        />
        <Box
          width={{ xs: "100%", sm: "95%" }}
          paddingTop={{ xs: "0%", sm: "0%" }}
        >
          {services.map((data, index) => (
            <Box key={index}>
              <Typography
                variant="h4"
                fontWeight={700}
                textAlign={"left"}
                color={"#948979"}
              >
                {" "}
              </Typography>

              <Typography
                variant="body1"
                fontWeight={400}
                paddingBottom={{ xs: "4%", sm: "1%" }}
                textAlign={"left"}
                color={"#000"}
              >
                &#8226; {data.details}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default WhoWillFund;
